// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2U1TM","approved":"Status_approved__2Qs7n","rejected":"Status_rejected__1CxJm","expired":"Status_expired__326KT","label":"Status_label__3rBKy"};